import { IBaoCaoTienBoSelectRequest } from "../../../models/request/bao-cao-tien-do/BaoCaoTienBoSelectRequest";
import { IBaoCaoTienDoVmConfirm } from "../../../models/response/bao-cao-tien-do/IBaoCaoTienDoVmConfirm";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eTheoDoiRCDefine = {
    CHANGE_FILTER: {} as IBaoCaoTienBoSelectRequest,
    LOAD_START: {} as IBaoCaoTienBoSelectRequest,
    LOAD_SUCCESS: [] as IBaoCaoTienDoVmConfirm[],
    LOAD_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: ""
}
export const eTheoDoiRCActionTypeIds = generateActionTypeIds(eTheoDoiRCDefine, "THEO_DOI_RC")
export type ITheoDoiRCActionTypes = IGenericActionType<typeof eTheoDoiRCDefine, "THEO_DOI_RC">